import { Injectable } from '@angular/core';
import { uniq } from 'lodash-es';
import { map, Observable } from 'rxjs';
import { GetAspectsResponse } from '../../api/core/models/api/get-aspects-response';
import { HttpApiService } from '../../api/core/services';
import { Dict } from '../../model/dict';
import { TransitionElement } from '../../model/enums/transition-element';
import { Tree } from './model/tree';
import { ClimateCortexModel_v3 } from '../climate-engine/model/climate-cortex-model';
import { EstimatesService } from '../../api/data-definitions/services/estimates.service';
import { ModelService } from '../../api/data-definitions/services/model.service';

@Injectable({ providedIn: 'root' })
export class BackendModelService {
  constructor(
    private _estimatesService: EstimatesService,
    private _coreHttpService: HttpApiService,
    private _modelService: ModelService
  ) {}

  getAspects(teId: TransitionElement): Observable<GetAspectsResponse> {
    return this._coreHttpService.getAspects({ id: teId });
  }
  /**
   *
   * @param teIds
   * @returns A dictionary indexed by the transition element containing an array of cobenefits. The have to be translated @see generateModelTranslationKey
   */
  getCoBenefits(teIds: TransitionElement[]): Observable<Dict<string[]>> {
    return this._coreHttpService.getCobenefits({ ids: teIds }).pipe(
      map((result) => {
        const elements = result.transitionElements ?? [];
        const coBenefits = elements.reduce((dict: Dict<string[]>, item) => {
          dict[item.transitionElement] = uniq(
            item.cobenefits?.map((coBenefit) => {
              if (coBenefit === 'expand_stock_lifetime') return 'increased_longevity_of_stock';
              return coBenefit;
            })
          );
          return dict;
        }, {});
        return coBenefits;
      })
    );
  }

  getModel(): Observable<ClimateCortexModel_v3> {
    return <Observable<ClimateCortexModel_v3>>this._modelService.getModel();
  }

  getTree(id: string): Observable<Tree> {
    return <Observable<Tree>>this._coreHttpService.getTree({ id });
  }

  listLocales(): Observable<string[]> {
    return this._estimatesService
      .listLocales()
      .pipe(map((res) => (res && res.locales?.length ? res.locales.map((l) => l.isoCode).sort() : [])));
  }
}
